import $ from 'jquery';
import { Autoplay, EffectFade, FreeMode, Mousewheel, Navigation, Pagination, Swiper, Thumbs } from 'swiper';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import GLightbox from 'glightbox';

import { $Elements, Events, Durations, Breakpoints, Classes } from './constants';
import { wait, loadExternalScript } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Carousel ----------

	$('.home-hero-section').each(async function() {

		const homeHeroInit = async() => {

			let homeMainSwiper = null,
				homeThumbSwiper = null;

			$(this).find('.home-content .section-carousel').each(function() {

				if(!this.swiper) {

					homeMainSwiper = new Swiper(this, {
						speed: Durations.animations.ms,
						observer: true,
						loop: true,
						allowTouchMove: false,
						slidesPerView: 'auto',
						centeredSlides: false,
						autoplay: {
							disableOnInteraction: false,
						},
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						modules: [Autoplay, EffectFade],
						on: {
							slideChangeTransitionStart: swiper => $(swiper.slides[swiper.activeIndex]).find('video').each((index, video) => {
								video.currentTime = 0;
								video.play();
							}),
						},
					});
				}

				$(this).find('.swiper-button-next').on('click', (event) => {

					homeThumbSwiper.slideNext();

					if(homeMainSwiper) {
						homeMainSwiper.slideNext();
					}
				});

				$(this).find('.swiper-button-prev').on('click', (event) => {

					homeThumbSwiper.slidePrev();

					if(homeMainSwiper) {
						homeMainSwiper.slidePrev();
					}
				});

			});

			$(this).find('.preview-content .section-carousel').each(function() {

				if(!this.swiper) {

					homeThumbSwiper = new Swiper(this, {
						speed: Durations.animations.ms,
						observer: true,
						loop: true,
						allowTouchMove: false,
						slidesPerView: 'auto',
						centeredSlides: false,
						autoplay: {
							disableOnInteraction: false,
						},
						modules: [Autoplay],
					});

					$(this).on('click', '.swiper-slide', (event) => {

						const index = event.currentTarget.dataset.swiperSlideIndex;

						if(homeThumbSwiper) {
							homeThumbSwiper.slideToLoop(parseInt(index));
						}

						if(homeMainSwiper) {
							homeMainSwiper.slideToLoop(parseInt(index));
						}
					});
				}
			});
		};

		if($Elements.body.hasClass('disclaimer-open')) {
			$Elements.document.on('disclaimer-closed', async() => await homeHeroInit());
		}
		else {
			await homeHeroInit();
		}
	});

	$('.simple-hero-section, .single-entity-hero-section').each(async function() {

		const simpleHeroInit = async() => {

			$(this).removeClass('introducing');

			if(window.innerWidth >= Breakpoints.mobile) {

				await wait(Durations.page.ms + 100);

				ScrollTrigger.refresh();
			}
		};

		if($Elements.body.hasClass('disclaimer-open')) {
			$Elements.document.on('disclaimer-closed', async() => await simpleHeroInit());
		}
		else {
			await simpleHeroInit();
		}
	});

	$('.wines-slider-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				observer: true,
				loop: false,
				slidesPerView: 1,
				centeredSlides: true,
				breakpoints: {
					[Breakpoints.mobile]: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					[Breakpoints.lg]: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					[Breakpoints.xxl]: {
						slidesPerView: 4,
						centeredSlides: false,
					},
				},
				preventInteractionOnTransition: true,
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	$('.other-entity-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				loop: false,
				slidesPerView: 1,
				breakpoints: {
					[Breakpoints.mobile]: {
						slidesPerView: 2.3,
					},
					[Breakpoints.xxl]: {
						slidesPerView: 3.3,
					},
				},
				observer: true,
				preventInteractionOnTransition: true,
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	$('.dates-section').each(function() {

		const slider = this.querySelector('.section-carousel');
		const pagination = this.querySelector('.pagination-carousel');

		if(pagination && !pagination.swiper) {

			const paginationSwiper = new Swiper(pagination, {
				speed: Durations.default.ms,
				modules: [FreeMode, Mousewheel],
				slidesPerView: 'auto',
				centerInsufficientSlides: true,
				observer: true,
				freeMode: true,
				watchSlidesProgress: true,
				mousewheel: {
					sensitivity: 2
				},
			});

			if(slider && !slider.swiper) {

				const mainSwiper = new Swiper(slider, {
					speed: Durations.default.ms,
					modules: [Thumbs],
					slidesPerView: 1,
					autoHeight: true,
					breakpoints: {
						1024: {
							slidesPerView: 1.3,
						},
					},
					observer: true,
					freeMode: true,
					loop: true,
					thumbs: {
						swiper: paginationSwiper,
					}
				});

				$(slider).find('.swiper-button-next').each(function() {
					$(this).on('click', (event) => {

						paginationSwiper.slideNext();
						mainSwiper.slideNext();

					});
				});
				$(slider).find('.swiper-button-prev').each(function() {
					$(this).on('click', (event) => {

						paginationSwiper.slidePrev();
						mainSwiper.slidePrev();

					});
				});
			}
		}

	});

	$('.vintages-timeline-section .vintages-slider').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				modules: [FreeMode, Mousewheel],
				slidesPerView: 'auto',
				centerInsufficientSlides: true,
				observer: true,
				freeMode: true,
				mousewheel: {
					sensitivity: 2
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Range List Section ----------

	$('.range-list-section').each((i, e) => {

		const links = $(e).find('a[data-page]');
		const images = $(e).find('.images .image');

		links.on('mouseenter touchstart', function() {
			links.removeClass(Classes.active);
			images.removeClass(Classes.active);
			$([this, images.get(parseInt(this.dataset.page, 10))]).addClass(Classes.active);
		});

		links.first().trigger('mouseenter');
	});

	$('.regiondo-widget-section').each(function () {
		const section = $(this);
		const script = section.find('.content script[src]').first();

		if (script.length) {
			loadExternalScript(script);
		}
	});

});

// ---------- Vintage Reviews Carousel ----------

export async function initSwiperReviews() {

	$('.reviews-vintage-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.default.ms,
				observer: true,
				loop: false,
				spaceBetween: 20,
				slidesPerView: 1.2,
				grabCursor: true,
				breakpoints: {
					768: {
						slidesPerView: 2.2,
						slidesPerGroup: 2,
					},
					1024: {
						slidesPerView: 3.2,
						slidesPerGroup: 3,
					},
					1280: {
						slidesPerView: 4.2,
						slidesPerGroup: 4,
					},
				},
				preventInteractionOnTransition: true,
				modules: [Navigation, Pagination],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					clickable: true,
					type: "progressbar",
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	$('.reviews-vintage-section .review-modal').each(function() {

		const modal = GLightbox({
			width: 'auto',
			height: 'auto',
			zoomable: false,
			draggable: false,
			closeButton: false,
			touchNavigation: false,
			openEffect: 'fade',
			closeEffect: 'fade',
			skin: 'clean size-md',
			elements: [{ content: this }],
		});

		modal.on('open', () => $(modal.getActiveSlide()).on('click', '[data-close]', () => modal.close()));

		$('[data-review-modal="' + this.attributes.id.value + '"]').on('click', () => modal.open());

	});

	await wait(Durations.default.ms);

	ScrollTrigger.refresh();
}
